module.exports = __webpack_public_path__ + "static/media/tdsEngland1.24dde927.png";